'use client'

import { useEffect } from 'react'
import { isPurMode } from '@/utils/app/paid'
import adAllianceLib from '@/libs/AdAlliance/AdAlliance.lib'
import AppContext from '@/types/context'
import { useConsentReady } from '@/hooks/useConsentReady'

export default function AdAlliance({ context }: { readonly context: AppContext }) {
  const consentReady = useConsentReady()

  useEffect(() => {
    const purMode = isPurMode(context.cookies)

    const metadata = context.metadata
    const isSportTag =
      metadata?.model?.article?.type === 'article-collection' && metadata?.model?.sectionName === 'Der Sport-Tag'
    console.log('cookies', context.cookies)
    console.log('purMode', purMode)
    if (!purMode && consentReady && !context.metadata?.model.adsDisable) {
      console.log('[AdA] initializing')
      adAllianceLib({
        adZone: isSportTag ? 'sporttag' : 'sport',
        adKeywords: context.metadata?.model.adKeywords ?? [],
        pageType: context.metadata?.model.pageType ?? 'Unknown',
        isWebView: context.webview,
      })
    }
  }, [consentReady])

  return <></>
}
